import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["className", "cssModule", "valid", "tooltip", "tag"];
import React from 'react';
import classNames from 'classnames';
import { mapToCssModules, tagPropType } from './utils';
var defaultProps = {
  tag: 'div',
  valid: undefined
};
var FormFeedback = function FormFeedback(props) {
  var className = props.className,
    cssModule = props.cssModule,
    valid = props.valid,
    tooltip = props.tooltip,
    Tag = props.tag,
    attributes = _objectWithoutPropertiesLoose(props, _excluded);
  var validMode = tooltip ? 'tooltip' : 'feedback';
  var classes = mapToCssModules(classNames(className, valid ? "valid-" + validMode : "invalid-" + validMode), cssModule);
  return /*#__PURE__*/React.createElement(Tag, _extends({}, attributes, {
    className: classes
  }));
};
FormFeedback.defaultProps = defaultProps;
export default FormFeedback;